import { Fragment, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  selectSelectedElement,
  selectSelectedElementType,
  selectSelectedTake3D,
  updateSelectedInteraction,
} from "../../app/slices/TrainingSlice";
import { Viewport3DLayerProps } from "./Viewport3DEnvironmentMetadata";
import { useMapEvents } from "react-leaflet";
import { ISetCamera } from "../../models/interactions/SetCamera";
import useCameraHelper from "../../hooks/CameraHelper.hook";
import { resolveCameraTakeLocation } from "./environmentLayerVisibility";
import { selectExpandedTakeLocationIds } from "../../app/slices/GlobalSlice";

export default function Viewport3DSetCameraLayer(props: Viewport3DLayerProps) {
  const dispatch = useDispatch();
  const { currentTakeLocation, isCameraSelected } = { ...props };
  const currentTake = useSelector(selectSelectedTake3D);
  const selectedElementType = useSelector(selectSelectedElementType);
  const setCam = useSelector(selectSelectedElement) as ISetCamera;
  const currentCamId = setCam.cameraId;
  const expandedFromStore = useSelector(selectExpandedTakeLocationIds);
  const expandedTakeLocationIds = expandedFromStore ?? [];
  const { getAllCameraPointsForTakeLocation, getSelectedCamForTakeLocation } =
    useCameraHelper();

  const map = useMapEvents({
    click: (e) => {
      if (setCam.isSelecting)
        dispatch(
          updateSelectedInteraction({
            ...setCam,
            isSelecting: false,
          } as ISetCamera)
        );
    },
  });

  // A Set Camera may cut to a camera at any take location: show the cameras of every
  // unfolded location, and of the selected camera's location (Viewport3DCameraPicking
  // unfolds that one and moves the map there).
  const cameraLocation = resolveCameraTakeLocation(
    props.takePositions,
    setCam.takeLocationId,
    currentTake
  );
  const otherLocations = props.takePositions.filter(
    (point) =>
      point.id !== currentTakeLocation?.id &&
      (expandedTakeLocationIds.includes(point.id) || point.id === cameraLocation?.id)
  );

  const pickCamera = (cameraId: string, takeLocationId: string) => {
    if (cameraId === currentCamId) return;

    const updatedInteraction: ISetCamera = {
      ...setCam,
      cameraId: cameraId,
      takeLocationId,
    };
    dispatch(updateSelectedInteraction(updatedInteraction));
  };
  const onCamPointClick = (cameraId: string) =>
    pickCamera(cameraId, currentTakeLocation!.id);

  const onSelectedCamClick = () => {
    dispatch(
      updateSelectedInteraction({ ...setCam, isSelecting: true } as ISetCamera)
    );
  };

  // const cams = useMemo(() => {
  //   // handle situations here

  //   return currentTakeLocation?.camera_positions.map((cam, index) => {
  //     return (
  //       <InteractionPointPreview
  //         strategy={
  //           currentCamId === cam.id
  //             ? SelectedCameraPointStrategy
  //             : CameraPointStrategy
  //         }
  //         x={cam.position.x}
  //         y={cam.position.y}
  //         key={index}
  //         onClick={() => onCamPointClick(cam.id)}
  //       />
  //     );
  //   });
  // }, [currentTake, setCam.id]);

  // const selectedCam = useMemo(() => {
  //   if (!currentTake) return <></>;

  //   const cid = setCam.cameraId;

  //   const camPos = currentTakeLocation?.camera_positions.find(
  //     (cam) => cam.id === cid
  //   );

  //   if (camPos)
  //     return (
  //       <InteractionPointPreview
  //         key={camPos.id}
  //         strategy={SelectedCameraPointStrategy}
  //         x={camPos.position.x}
  //         y={camPos.position.y}
  //         onClick={onSelectedCamClick}
  //       />
  //     );
  //   else return <></>;
  // }, [setCam, setCam.id]);

  const cams = useMemo(() => {
    if (!currentTakeLocation) return <></>;

    return getAllCameraPointsForTakeLocation(
      currentTakeLocation,
      setCam.cameraId,
      onCamPointClick
    );
  }, [getAllCameraPointsForTakeLocation, currentTakeLocation, onCamPointClick]);

  const selectedCam = useMemo(() => {
    if (!currentTakeLocation) return <></>;

    return getSelectedCamForTakeLocation(
      currentTakeLocation,
      setCam.cameraId,
      onSelectedCamClick
    );
  }, [getSelectedCamForTakeLocation, currentTakeLocation, onSelectedCamClick]);

  return (
    <>
      {/* {setCam.isSelecting && cams}
      {setCam.cameraId && selectedCam} */}
      <Fragment key={currentTakeLocation?.id}>{cams}</Fragment>
      {otherLocations.map((location) => (
        <Fragment key={location.id}>
          {getAllCameraPointsForTakeLocation(location, setCam.cameraId, (cameraId) =>
            pickCamera(cameraId, currentTake?.situations[location.id] ?? location.id)
          )}
        </Fragment>
      ))}
    </>
  );
}
